/**
 * Portal Manta · agSimilarCalc
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function agSimilarCalc(ctx, prev){
  const {projeto, casosFiltrados, pesoFis} = ctx;
  if (!casosFiltrados || casosFiltrados.length===0) return {status:'sem-casos'};
  const featNames = ['densDup','densMarg','densCicl','densOae','densInter'];
  const pCtx = 1 - (pesoFis ?? 0.7);
  const ranking = casosFiltrados.map(l => {
    const va = featNames.map(f => l[f]||0);
    const vb = featNames.map(f => projeto[f]||0);
    const vca = [l.ctxRural, l.ctxUrbano, l.ctxSerra, (l.chuvaMM||1500)/2500];
    const vcb = [projeto.ctxRural, projeto.ctxUrbano, projeto.ctxSerra, projeto.chuvaNorm];
    const cosFis = cosseno(va, vb);
    const cosCtx = cosseno(vca, vcb);
    const cos = (pesoFis??0.7)*cosFis + pCtx*cosCtx;
    return {sig:l.sig, sigla:l.sigla, uf:l.uf, cosFis, cosCtx, cos, score: Math.round(cos*100)};
  }).sort((a,b)=> b.cos - a.cos);
  return {
    sub:'Calculador de Similaridade',
    status:'ok',
    ranking,
    topMatch: ranking[0],
    msg: `Top: ${ranking[0]?.sigla} · ${ranking[0]?.score}%`,
  };
}

export { agSimilarCalc };
export default agSimilarCalc;
